import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";
import { Logo } from "./Logo";

const SERVICES = [
  { label: "House Moving", to: "/services/house-movers-melbourne" },
  { label: "Apartment Moving", to: "/services/apartment-unit-removalists" },
  { label: "Office Relocation", to: "/services/office-moving-relocation" },
  { label: "Furniture Removal", to: "/services/furniture-removal-melbourne" },
  { label: "Packing Services", to: "/services/packing-services" },
  { label: "Same-Day Moving", to: "/booking" },
  { label: "Interstate Removalists", to: "/services/interstate-removalists" },
];

const AREAS = ["Inner North", "North", "East", "West", "City & Inner East", "South-East & Bayside"];

export const Footer = () => (
  <footer className="bg-slate-900" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-24">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <span className="inline-block rounded-xl bg-white px-4 py-2.5 shadow-md">
            <Logo size="md" testid="footer-logo" />
          </span>
          <p className="mt-5 max-w-xs text-sm font-semibold text-slate-300">
            Professional Melbourne Removalists
          </p>
          <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-400">
            Reliable local and interstate movers for house moves, office relocations, furniture removal and packing services.
          </p>
          <p className="mt-3 text-xs font-medium tracking-wide text-slate-500">
            From $69/hr &nbsp;|&nbsp; Fully Insured &nbsp;|&nbsp; Free Quotes*
          </p>
          <p className="mt-6 font-display text-lg font-semibold text-white">Ready to Move?</p>
          <p className="mt-1 text-sm text-slate-400">Get your free moving quote today.</p>
          <Link
            to="/#quote"
            className="mt-4 inline-block rounded-lg bg-blaze px-6 py-3 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-blue-700"
            data-testid="footer-quote-btn"
          >
            Get a Free Quote
          </Link>
        </div>
        <div className="md:col-span-3">
          <p className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-slate-500">Services</p>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.label}>
                <Link to={s.to} className="text-sm text-slate-300 transition-colors hover:text-blue-400">{s.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-slate-500">Areas</p>
          <ul className="space-y-3">
            {AREAS.map((a) => (
              <li key={a} className="text-sm text-slate-300">{a}</li>
            ))}
          </ul>
          <p className="mt-4 text-xs leading-relaxed text-slate-500">Serving Greater Melbourne &amp; Interstate Australia</p>
        </div>
        <div className="md:col-span-3">
          <p className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-slate-500">Contact Us</p>
          <ul className="space-y-3 text-sm text-slate-300">
            <li>
              <a href="tel:0391136005" className="flex items-center gap-3 transition-colors hover:text-blue-400" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-blue-400" /> 03 9113 6005
              </a>
            </li>
            <li>
              <a href="mailto:info@moversnearby.com.au" className="flex items-center gap-3 transition-colors hover:text-blue-400" data-testid="footer-email">
                <Mail className="h-4 w-4 text-blue-400" /> info@moversnearby.com.au
              </a>
            </li>
            <li>
              <a href="https://instagram.com/moversnearby" target="_blank" rel="noreferrer" className="flex items-center gap-3 transition-colors hover:text-blue-400" data-testid="footer-instagram">
                <Instagram className="h-4 w-4 text-blue-400" /> @moversnearby
              </a>
            </li>
            <li className="flex items-center gap-3 text-slate-400">
              <MapPin className="h-4 w-4 text-blue-400" /> Melbourne, VIC, Australia
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-slate-800 pt-8 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} MoversNearby. All Rights Reserved.</p>
        <div className="flex flex-wrap items-center gap-5 uppercase tracking-widest">
          <Link to="/privacy" className="transition-colors hover:text-blue-400" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/terms" className="transition-colors hover:text-blue-400" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
          <a href="/#insurance" className="transition-colors hover:text-blue-400" data-testid="footer-insurance-link">Insurance Information</a>
        </div>
      </div>
    </div>
  </footer>
);
